import { TriangleRight } from "@styled-icons/entypo";
import { Typography } from "components/parts/Typography/Typography";
import { fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";
import styled from "styled-components";

export const StyledInterviewList = styled.div`
  min-height: 70px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledInterview = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0.5rem 1rem 1.5rem;
  border-bottom: solid 1px ${newColors.border};
  cursor: pointer;

  .icon_arrow {
    transform: rotate(-90deg);
    width: 45%;
  }

  :hover {
    background: ${newColors.hover};
  }
`;

export const StyledToggleIcon = styled.div`
  margin-right: 20px;
`;

export const StyledNotificationEvent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem 1rem 1.5rem;
  border-bottom: solid 1px ${newColors.border};
  cursor: pointer;

  .icon_arrow {
    transform: rotate(-90deg);
    width: 45%;
  }

  :hover {
    background: ${newColors.hover};
  }
`;

export const StyledInterviewSeq = styled(Typography)`
  min-width: 1.5em;
`;

export const StyledInterviewTitle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const StyledNotificationEventTitle = styled.div`
  margin-left: 3rem;
  display: flex;
  gap: 1rem;
`;

export const StyledTriangleRight = styled(TriangleRight)`
  display: flex;
  width: ${fontSize.xxlarge};
  height: ${fontSize.xxlarge};
  color: ${newColors.primary};
  margin-right: 1rem;
`;
